<template>
<div class="clearfix">
    <div class="item-container">
        <el-card class="card">
            <div class="top-container">
              <p class="top-span p-first">亲爱的{{inviteName}}</p>
              <p class="top-span">欢迎加入闻景科技，{{sponsor}}邀请您成为{{deptName}}的{{roleName}}</p>
            </div>
            <span class="phone-span" >{{phone}}</span>
            <div class="item-column">
                <span class="span-hint" v-show="!verify_status">{{verify_hint}}</span>
                <div class="item-row">
                    <el-input placeholder="输入验证码" size="medium" v-model="verify_code" @blur='verifyOnBlur' @keyup.enter.native="signup" maxlength=11 clearable></el-input>
                    <el-button class="btn-verify" size="medium" @click="getVerifyCode" type="primary" :loading='vloading' :disabled="verify_disable">{{btn_verify}}</el-button>
                </div>
            </div>
            <div class="item-column">
                <el-button class="btn-confirm" size="medium" type="primary" @click="signup" :loading='loading'>确认邀请</el-button>
            </div>
            <el-dialog class='confirm-dialog' :visible.sync="dialogVisible" :modal-append-to-body="dialogToBody" :show-close="dialogToBody" width="280px" title="验证成功">
              <div class="dialog-wrapper">
                <!-- <h3>验证成功</h3> -->
                <span style="margin-top: 15px;">
                    请登录闻景科技平台，完善资料。<br>您也可以关注闻景科技官方公众号，获取更多动态资讯。
                </span>
                <img class="qrcode" src="../../../static/image/wx_public_qr.png"/>
              </div>

            </el-dialog>
        </el-card>
    </div>


</div>
</template>
<script>
import utils from '@/js/utils.js'

var args=utils.getRequest(location.href)

export default {
    data () {
        return {
            phone_hint:'请输入手机号',
            phone_status:true,
            phone:'',
            securityNo:'',
            verify_hint:'请输入验证码',
            verify_status:true,
            verify_code:'',
            btn_verify:'获取验证码',
            verify_disable:false,
            verify_second:60,
            loading:false,
            vloading:false,
            dialogVisible: false,
            dialogToBody:false,
            inviteName:'',
            roleName:'',
            sponsor:'',
            deptName:''
        }
    },
    mounted:function(){
        this.getInviteName()
    },
    methods:{
        getInviteName(){
            var codeParams = {
                inviteId:args.inviteId
            }
            this.wjtHttp.get(this,'/api/invite/v1/info',codeParams,true,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.inviteName=data.info.inviteName;
                    this.phone=data.info.phone;
                    this.securityNo=data.securityNo;
                    this.roleName=data.info.roleName;
                    this.sponsor=data.info.sponsor;
                    this.deptName=data.info.deptName;
                }else{
                    this.inviteName='客户'
                    this.$message({
                        message: data.msg?data.msg:"邀请信息获取失败，请联系管理员",
                        type: 'error'
                    });
                }
            },(err)=>{
                this.inviteName='客户'
                this.$message({
                    message: "邀请信息获取失败，请联系管理员",
                    type: 'error'
                });
            })
        },
        getVerifyCode(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请先填写手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请先填写正确的手机号',
                    type: 'fail'
                });
                return
            }
            var codeParams = {
                telephone:this.phone,
                phoneMd5:this.$md5(this.phone),
                type:'invite',
                securityNo:this.securityNo
            }
            this.vloading = true
            this.wjtHttp.get(this,'/api/smsCode',codeParams,false,(res)=>{
                this.vloading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message:'发送成功',
                        type:'success'
                    })
                    this.verify_disable = true
                    clearInterval(this.mInterval)
                    this.mInterval = setInterval(() => {
                        if(this.verify_second == 0){
                            this.verify_disable = false
                            this.verify_second = 60
                            clearInterval(this.mInterval)
                            return
                        }
                        this.verify_second--
                    }, 1000);
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.vloading = false
            })
        },
        phoneOnBlur(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
            }else if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
            }else{
                this.phone_status = true
            }
        },
        verifyOnBlur(){
            if(this.verify_code.length == 0){
                this.verify_status = false
                this.verify_hint='请输入验证码'
            }else{
                this.verify_status = true
            }
        },
        signup(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请输入手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'fail'
                });
                return
            }
            if(this.verify_code.length == 0){
                this.$message({
                    message: '请输入验证码',
                    type: 'fail'
                });
                return
            }
            var signupParams = {
                telephone:this.phone,
                code:this.verify_code,
                phoneMd5:this.$md5(this.phone),
                inviteId:args.inviteId,
                securityNo:this.securityNo
            }
            this.loading = true
            this.wjtHttp.post(this,'/api/invite/v1/confirm',signupParams,false,(res)=>{
                this.loading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message: '请登录闻景科技平台，完善资料。您也可以关注闻景科技官方公众号，获取更多动态资讯。<br>这是个二维码',
                        type: 'success'
                    });
                    this.dialogVisible=true;
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.loading = false
            })
        }
    },
    watch:{
        verify_disable:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        verify_second:function(val){
            if(val < 60){
                this.btn_verify = val + '后重发'
            }
        }
    }
}
</script>
<style scoped>
    .item-container{
      width: auto;
        margin: 0 auto;
        position: relative;
    }
    .card{
        margin: 30px auto;
        background-color: #fff;
        max-width: 420px;
        width: 100%;
    }
    .top-container{
      width: 100%;
      min-height: 120px;
      display: flex;
      flex-direction: column;
      background-image: url(../../../static/image/bg_invite.png);
      background-size: 100% 100%;
      padding-top: 20px;
      padding-bottom: 5px;
    }
    .dialog-wrapper{
      width: calc(100% - 20px);
      margin: 10px 10px;
      height: auto;
      position: relative;
      bottom: 30px;
    }
    .dialog-wrapper>span{
      width: 100%;
      display: flex;
      text-align: left;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .top-span{
      color: white;
      font-size: 20px;
      display: flex;
      text-align: left;
      margin-left: 7%;
      margin-right: 3%;
      margin-bottom: 5px;
    }
    .p-first{
      margin-bottom: -15px;
    }
    .logo{
        width: 100%;
    }
    .qrcode{
      width: 80px;
      height: 80px;
      margin-top: 20px;
      margin-bottom: -40px;
    }
    .span-hint{
        font-size: 16px;
        color: #ce9477;
        padding: 5px 0;
        text-align: left;
    }
    .phone-span{
      font-size: 16px;
      color: #ce9477;
      padding: 5px 0;
      text-align: left;
      display: flex;
      flex-direction: column;
      margin-bottom: 22px;
      margin-left: 7%;
      margin-right: 7%;
      margin-top: 50px;
    }
    .item-column{
        display: flex;
        flex-direction: column;
        margin-bottom: 22px;
        margin-left: 7%;
        margin-right: 7%;
        margin-top:30px;
    }
    .item-row{
        display: flex;
        flex-direction: row;
    }
    .btn-verify{
        margin-left: 18px;
    }
    .btn-confirm{
        width: 100%;
        height: 45px;
        margin-top: 28px;
        margin-bottom: 50px;
    }
    .span-third-login{
        font-size: 16px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        color: #333333;
    }
    .img-wx{
        width: 36px;
        height: 36px;
        margin-top: 20px;
        position: relative;
        margin-left: calc(50% - 16px);
    }
    .span-signup-text{
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .span-signup-text>span{
        font-size: 16px;
        color: #FE9400;
    }
</style>



// WEBPACK FOOTER //
// src/components/account/Invite.vue